export default __webpack_public_path__ + "static/media/Home7.0357133e.png";